import { createAction, createActions } from "redux-actions";
import { Users, User } from "./types";

const { addUsers } = createActions<[]>("ADD_USERS");
const addUser = createAction<Partial<User>>("ADD_USER");
const updateUser = createAction<Partial<User>>("UPDATE_USER");
const { getUsers } = createActions<[]>("GET_USERS");
const { getUsersSuccess } = createActions<Users>("GET_USERS_SUCCESS");
const { getUsersFailure, getUsersIdle } = createActions("GET_USERS_FAILURE", "GET_USERS_IDLE");

const { getCurrentUser, getCurrentUserFailure, getCurrentUserIdle } = createActions(
  "GET_CURRENT_USER",
  "GET_CURRENT_USER_FAILURE",
  "GET_CURRENT_USER_IDLE"
);
const { getCurrentUserSuccess } = createActions<User>("GET_CURRENT_USER_SUCCESS");

export {
  addUser,
  updateUser,
  addUsers,
  getUsers,
  getUsersSuccess,
  getUsersFailure,
  getUsersIdle,
  getCurrentUser,
  getCurrentUserFailure,
  getCurrentUserIdle,
  getCurrentUserSuccess,
};
